module.exports = __webpack_public_path__ + "img/receipt33.4d9d9a63.svg";